import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import CommentsItem from "./CommentsItem.vue"
import CommentsEdit from "./CommentsEdit.vue"
import { computed , ref } from "vue"
import { useStore } from "vuex"


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentsList',
  props: {
  source: {
    type: Object,
    default () {
      return {}
    }
  },
  index: {
    type: Number
  },
},
  emits: ['editing'],
  setup(__props, { emit: __emit }) {

const store = useStore()
const editing = ref<Object>({
  acl: 'all',
  id: '',
  text: '',
  publicBelowOrg: null
})

const props = __props

const emit = __emit
const username = computed(() => store.state.user.username)
const canAddAndEditComments = computed(() => store.getters['user/canAddAndEditComments'])
const canEditAllComments = computed(() => store.getters['user/canEditAllComments'])
const editingComment = computed(() => store.state.content.comments.editingComment)

const removeComment = async (val: any) => {
  await store.dispatch('content/updatingComments', true)
  await store.dispatch('content/removeComment', { comment: val, deleteOnly: true })
  await store.dispatch('content/clearComments')
  await store.dispatch('content/getComments')
  await store.dispatch('content/updatingComments', false)
}
const clearEditingComment = async () => {
  await store.dispatch('content/editingComment', null)
}
const cancel = async () => {
  await store.dispatch('content/revertComment', props.source)
  editing.value = {
    id: '',
    text: '',
    acl: 'all'
  }
  await clearEditingComment()
}
const edit = async (comment: any) => {
  await clearEditingComment()
  editing.value = JSON.parse(JSON.stringify(comment))
  await store.dispatch('content/editingComment', { comment: props.source })
}
const submit = async (value: any) => {
  await store.dispatch('content/saveComment', { comment: props.source, saveOnly: true })
  await clearEditingComment()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommentsItem, {
      comment: __props.source,
      username: username.value,
      editing: editingComment.value?.id === __props.source.id,
      "can-add-and-edit-comments": canAddAndEditComments.value,
      "can-edit-all-comments": canEditAllComments.value,
      onEdit: edit,
      onRemove: removeComment
    }, {
      default: _withCtx(() => [
        (editingComment.value?.id === __props.source.id)
          ? (_openBlock(), _createBlock(CommentsEdit, {
              key: 0,
              comment: __props.source,
              onSubmit: submit,
              onCancel: cancel
            }, null, 8, ["comment"]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }, 8, ["comment", "username", "editing", "can-add-and-edit-comments", "can-edit-all-comments"]),
    _hoisted_1
  ], 64))
}
}

})